import React from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory, {
  PaginationProvider,
  SizePerPageDropdownStandalone,
  PaginationListStandalone,
} from 'react-bootstrap-table2-paginator'
import { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css'
import './navoverrides.css'

const { SearchBar } = Search
const { ExportCSVButton } = CSVExport

const defaultSorted = [
    {
      dataField: 'lastBackupDate',
      order: 'desc',
    },
  ]

const ExcludedUsersTable = ({ reportDetails, selectedCompany }) => {
    const columns = [
        {
          dataField: 'displayName',
          text: 'Name',
          sort: true,
          editable: false,
          filter: textFilter({
            placeholder: 'Filter Mailbox...',
          }),
        },
        {
          dataField: 'email',
          text: 'Email',
          sort: true,
          editable: false,
          filter: textFilter({
            placeholder: 'Filter Email...',
          }),
        },
        {
          dataField: 'exclusionGroup',
          text: 'Exclusion Group',
          sort: true,
          editable: false,
          filter: textFilter({
            placeholder: 'Filter Email...',
          }),
        },
        {
            dataField: 'exclusionReason',
            text: 'Exclusion Reason',
            sort: true,
            editable: false,
            filter: textFilter({
                placeholder: 'Filter Reason...',
            }),
        },
        {
            dataField: 'jobName',
            text: 'Job Name',
            sort: true,
            editable: false,
            filter: textFilter({
                placeholder: 'Filter Job...',
            }),
        }
    ]
    return (
        <div>
            <PaginationProvider
                pagination={paginationFactory({
                    custom: true,
                    totalSize: reportDetails.veeamExcludedUsers.length,
                    sizePerPageList: [
                    { text: '10', value: 10 },
                    { text: '20', value: 20 },
                    { text: '50', value: 50 },
                    { text: '100', value: 100 },
                    { text: 'All', value: reportDetails.veeamExcludedUsers.length },
                    ],
                })}>
          {({ paginationProps, paginationTableProps }) => (
            <ToolkitProvider
              bootstrap4
              keyField="id"
              data={reportDetails.veeamExcludedUsers}
              columns={columns}
              exportCSV={{
                fileName: `${selectedCompany && selectedCompany.label}-veeam.csv`,
                onlyExportFiltered: true,
                exportAll: false,
              }}
              search
            >
              {(props) => {
                return (
                  <div>
                    <PaginationListStandalone style={{ marginLeft: '20px' }} {...paginationProps} />
                    <ExportCSVButton className="btn-outline-primary" {...props.csvProps}>
                      Export Data
                    </ExportCSVButton>{' '}
                    <SearchBar {...props.searchProps} />
                    <SizePerPageDropdownStandalone
                      btnContextual="btn-outline-primary"
                      className="dropDownStyle"
                      {...paginationProps}
                    />
                    <BootstrapTable
                      defaultSorted={defaultSorted}
                      bordered={false}
                      {...props.baseProps}
                      pagination={paginationFactory()}
                      filter={filterFactory()}
                      filterPosition="top"
                      {...paginationTableProps}
                    />
                  </div>
                )
              }}
            </ToolkitProvider>
          )}
        </PaginationProvider>
        </div>
    )
}

export default ExcludedUsersTable